import { KASPI_DETECT_COOKE, KASPI_LANGUAGE_COOKE, KASPI_VERSION_COOKE } from '../constants'
import type {
  KaspiGetGeolocationPayload,
  KaspiIsGeolocationEnabledPayload,
  OnMessageCallback,
} from '../types'
import { initKaspiWebView, postMessage } from './helpers'
import { getCookie } from '@/tools/cookies'
import type { Language } from '@/tools/i18n'

if (isKaspiWebView()) {
  initKaspiWebView()
}

const assesIsKaspiWebView = () => {
  if (!isKaspiWebView()) {
    throw new Error('[Kaspi]: App is not running in Kaspi WebView')
  }
}

export function authWithKaspi(config: { state: string }, callback: OnMessageCallback): void {
  assesIsKaspiWebView()
  postMessage('oauth', config, callback)
}

export function payWithKaspi(config: { transportId: string }, callback: OnMessageCallback): void {
  assesIsKaspiWebView()
  postMessage('opay', config, callback)
}

export function showKaspiCloseButton(): void {
  assesIsKaspiWebView()
  postMessage('setCloseButtonState', { isHidden: false })
}

export function hideKaspiCloseButton(): void {
  assesIsKaspiWebView()
  postMessage('setCloseButtonState', { isHidden: true })
}

function getCurrentGeolocation(
  config: KaspiGetGeolocationPayload,
  callback: OnMessageCallback
): void {
  assesIsKaspiWebView()
  postMessage('getCurrentGeolocation', config, callback)
}

function isGeoNavigationEnabled(config: KaspiIsGeolocationEnabledPayload): Promise<boolean> {
  assesIsKaspiWebView()
  return new Promise((resolve) => {
    postMessage('isGeoNavigationEnabled', config, resolve)
  })
}

export async function getGeolocationWithKaspi(
  config: KaspiGetGeolocationPayload,
  callback: OnMessageCallback
) {
  const isEnabled = await isGeoNavigationEnabled({ accessType: 'coarse' })
  getCurrentGeolocation({ ...config, isForced: !isEnabled }, callback)
}

export function getKaspiLanguage(): Language {
  const locale = getCookie(KASPI_LANGUAGE_COOKE)
  if (locale === 'ru-RU') {
    return 'ru'
  } else {
    return 'kk'
  }
}

export function isKaspiWebView(): boolean {
  const cookieValue = getCookie(KASPI_DETECT_COOKE)
  return Boolean(cookieValue)
}

export function getKaspiVersion(): string | null {
  const appVersion = getCookie(KASPI_VERSION_COOKE)
  return appVersion || null
}
